import { User } from "../gateway/User/User";

export class CompleteSignUpUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ _id = "", accountingId = "", password = "" } = {}) {
        const payload = this.sanitizeInput({ _id, accountingId, password });
        if (!payload._id) return null;
        if (!payload.accountingId) return null;
        if (!payload.password) return null;
        const response = await this.UserGateway.completeSignUp(payload);
        return response;
    }

    sanitizeInput({ _id = "", accountingId = "", password = "" } = {}) {
        const sanitizedId = String(_id).trim();
        const sanitizedAccountingId = String(accountingId).trim();
        const sanitizedPassword = String(password).trim();
        return {
            _id: sanitizedId,
            accountingId: sanitizedAccountingId,
            password: sanitizedPassword
        };
    }
}
